import React, { useEffect, useState } from "react";

import { NAME_MAX, validateParticipant } from "./participantHelpers";

const FIELDS = [
  { key: "first_name", label: "First Name", type: "text" },
  { key: "last_name", label: "Last Name", type: "text" },
  { key: "email_id", label: "Email ID", type: "email" },
];

const EMPTY = { first_name: "", last_name: "", email_id: "" };

/** Add/Edit participant modal from old/admin/participants.php. */
export default function ParticipantModal({ open, initial, existingEmails, onClose, onSubmit, isSaving }) {
  const [values, setValues] = useState(EMPTY);
  const [localError, setLocalError] = useState("");

  const isEdit = !!initial;

  useEffect(() => {
    if (!open) return;
    setValues(initial ? { ...EMPTY, ...initial } : EMPTY);
    setLocalError("");
  }, [open, initial]);

  if (!open) return null;

  const setField = (key, raw) => {
    // Names may not start with a space (old participants.php strips leading spaces as you type).
    const value = key === "email_id" ? raw : raw.replace(/^\s+/, "");
    setValues((prev) => ({ ...prev, [key]: value }));
    setLocalError("");
  };

  const submit = async () => {
    const participant = {
      first_name: values.first_name.trim(),
      last_name: values.last_name.trim(),
      email_id: values.email_id.trim(),
    };
    const error = validateParticipant(participant);
    if (error) {
      setLocalError(error);
      return;
    }
    const email = participant.email_id.toLowerCase();
    const ownEmail = String(initial?.email_id ?? "").toLowerCase();
    if (email !== ownEmail && existingEmails.includes(email)) {
      setLocalError("Duplicate Email! This email already exists.");
      return;
    }
    try {
      await onSubmit(participant);
    } catch {
      /* parent surfaces error */
    }
  };

  return (
    <div className="quiz-modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="quiz-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="participant-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="quiz-modal-header">
          <h2 id="participant-modal-title">{isEdit ? "Edit Participant" : "New Participant"}</h2>
          <button type="button" className="quiz-modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>

        <div className="quiz-modal-body">
          {localError ? <p className="cr-alert cr-alert-error quiz-modal-error">{localError}</p> : null}

          {FIELDS.map((f) => (
            <div className="quiz-modal-field quiz-modal-field--full" key={f.key}>
              <label htmlFor={`participant-${f.key}`}>{f.label}</label>
              <input
                id={`participant-${f.key}`}
                type={f.type}
                className="quiz-modal-textarea"
                placeholder={f.key === "email_id" ? "Enter Email" : f.label}
                value={values[f.key]}
                maxLength={f.key === "email_id" ? undefined : NAME_MAX}
                onChange={(e) => setField(f.key, e.target.value)}
                disabled={isSaving}
              />
              <p className="quiz-modal-limit">
                {f.key === "email_id"
                  ? "Please enter a valid email address (e.g., user@example.com)"
                  : `Max length ${NAME_MAX} characters`}
              </p>
            </div>
          ))}
        </div>

        <div className="quiz-modal-footer">
          <button
            type="button"
            className="quiz-modal-btn quiz-modal-btn-save"
            onClick={submit}
            disabled={isSaving}
          >
            <i className="fa-solid fa-cloud-arrow-up" aria-hidden />
            {isSaving ? "Saving…" : isEdit ? "Update" : "Submit"}
          </button>
          <button type="button" className="quiz-modal-btn quiz-modal-btn-close" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
